var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75C3 5.7875 3.81 5 4.8 5H18.3C18.5387 5 18.7676 5.09219 18.9364 5.25628C19.1052 5.42038 19.2 5.64294 19.2 5.875V6.75H4.8V7.625H20.1C20.3387 7.625 20.5676 7.71719 20.7364 7.88128C20.9052 8.04538 21 8.26794 21 8.5V17.25C21 17.7141 20.8104 18.1592 20.4728 18.4874C20.1352 18.8156 19.6774 19 19.2 19H4.8C4.32261 19 3.86477 18.8156 3.52721 18.4874C3.18964 18.1592 3 17.7141 3 17.25V6.75ZM17.85 14.625C18.208 14.625 18.5514 14.4867 18.8046 14.2406C19.0578 13.9944 19.2 13.6606 19.2 13.3125C19.2 12.9644 19.0578 12.6306 18.8046 12.3844C18.5514 12.1383 18.208 12 17.85 12C17.492 12 17.1486 12.1383 16.8954 12.3844C16.6422 12.6306 16.5 12.9644 16.5 13.3125C16.5 13.6606 16.6422 13.9944 16.8954 14.2406C17.1486 14.4867 17.492 14.625 17.85 14.625Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.3dea40c68d491e651e0c2ef2a58e0421.svg";
export { ForwardRef as ReactComponent };